import React, { FC, forwardRef } from 'react'
import { Flex, FlexDivProps } from 'components/Box'
import Spinner from './Spinner'

interface SpinnerFlexProps {
  primary?: boolean
  size?: string
}

const SpinnerFlex: FC<SpinnerFlexProps & FlexDivProps> = forwardRef(
  ({ primary, size, ...props }, forwardedRef) => (
    <Flex
      ref={forwardedRef}
      justifyContent="center"
      alignItems="center"
      {...props}>
      <Spinner primary={primary} size={size} />
    </Flex>
  )
)

SpinnerFlex.displayName = 'SpinnerFlex'

export default SpinnerFlex
